import { transport } from '@opengov/app-core/transport';
import { useMutation } from '@tanstack/react-query';
import { customReportsQueryKeys } from './customReportsQueryKeys';

type SpreadsheetTableResponse = {
  reference: {
    id: string;
    storyContentId: string;
    spreadsheetId: string;
    namedRangeId: string;
    title: string;
    createdAt: string;
    updatedAt: string;
  };
};

type Params = {
  entityId: number;
  publicationId: string;
  storyId: string;
  storyContentId: string;
  spreadsheetId: string;
  namedRangeId: string;
  title: string;
};

async function postSpreadsheetTable({
  entityId,
  publicationId,
  storyId,
  storyContentId,
  spreadsheetId,
  namedRangeId,
  title
}: Params): Promise<SpreadsheetTableResponse> {
  return transport
    .url(`/api/stories/v1/stories/${storyId}/content/${storyContentId}/spreadsheet-table`)
    .json({ entityId, publicationId, spreadsheetId, namedRangeId, title })
    .post()
    .json();
}

export function usePostSpreadsheetTable({
  entityId,
  publicationId,
  storyId,
  storyContentId
}: {
  entityId: number;
  publicationId: string;
  storyId: string;
  storyContentId: string;
}) {
  return useMutation({
    mutationKey: customReportsQueryKeys.postSpreadsheetTable({ entityId, publicationId, storyId, storyContentId }),
    mutationFn: postSpreadsheetTable
  });
}
